<template>
  <div class="pb-5">
    <label class="label">
      <VariableLabelString :label="label" />
    </label>
    <div class="field has-addons has-addons-centered" v-if="!constant && unit.content != ''">
      <div class="control">
        <input class="input" type="number" v-model="unitValue" />
      </div>
      <div class="control">
        <div class="select" v-if="unit.content === 's'">
          <select v-model="unitMultiplicator">
            <option value="1">* 1</option>
            <option value="86400">* 86400 (Tage)</option>
            <option value="3600">* 3600 (Stunden)</option>
            <option value="60">* 60 (Minuten)</option>
            <option value="0.001">* 10^-3 (Milli)</option>
            <option value="0.000001">* 10^-6 (Mikro)</option>
            <option value="0.000000001">* 10^-9 (Nano)</option>
          </select>
        </div>
        <div class="select" v-else>
          <select v-model="unitMultiplicator">
            <option value="1">* 1</option>
            <option value="1000000000">* 10^9 (Giga)</option>
            <option value="1000000">* 10^6 (Mega)</option>
            <option value="1000">* 10^3 (Kilo)</option>
            <option value="0.001">* 10^-3 (Milli)</option>
            <option value="0.000001">* 10^-6 (Mikro)</option>
            <option value="0.000000001">* 10^-9 (Nano)</option>
          </select>
        </div>
      </div>
    </div>
    <div class="field" v-else-if="!constant && unit.content == ''">
      <div class="control is-300px-width m-auto">
        <input class="input" type="number" v-model="unitValue" />
      </div>
    </div>
  </div>
</template>

<script>
import VariableLabelString from '@/components/VariableLabelString.vue'

export default {
  name: 'DefaultUnitInput',
  components: {
    VariableLabelString
  },
  props: {
    modelValue: { type: Object, required: true },
    label: { type: Object, required: true },
    unit: { type: Object, required: true },
    constant: { type: Boolean, required: true }
  },
  emits: ['update:modelValue'], // Bestätigt, dass das Event korrekt emittiert wird
  computed: {
    // Getter und Setter für unitValue, nutzt modelValue für den get und emittiert update:modelValue beim Setzen
    unitValue: {
      get () {
        // Rückgabe des aktuellen Wertes, sicherstellen, dass modelValue nicht null ist
        return this.modelValue ? this.modelValue.unitValue : null
      },
      set (newValue) {
        // Emittiert das update:modelValue Event mit dem aktualisierten Objekt
        this.$emit('update:modelValue', { ...this.modelValue, unitValue: newValue })
      }
    },
    // Getter und Setter für unitMultiplicator, nutzt modelValue für den get und emittiert update:modelValue beim Setzen
    unitMultiplicator: {
      get () {
        // Rückgabe des aktuellen Wertes, sicherstellen, dass modelValue nicht null ist
        return this.modelValue ? this.modelValue.unitMultiplicator : null
      },
      set (newValue) {
        // Emittiert das update:modelValue Event mit dem aktualisierten Objekt
        this.$emit('update:modelValue', { ...this.modelValue, unitMultiplicator: newValue })
      }
    }
  },
  methods: {
    convert (n) {
      const sign = +n < 0 ? '-' : ''
      const toStr = n.toString()
      if (!/e/i.test(toStr)) {
        return n
      }
      const [lead, decimal, pow] = n
        .toString()
        .replace(/^-/, '')
        .replace(/^([0-9]+)(e.*)/, '$1.$2')
        .split(/e|\./)
      return +pow < 0
        ? sign + '0.' + '0'.repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) + lead + decimal
        : sign + lead + (+pow >= decimal.length ? decimal + '0'.repeat(Math.max(+pow - decimal.length || 0, 0)) : decimal.slice(0, +pow) + '.' + decimal.slice(+pow))
    }
  }
}
</script>
